import React from 'react';
import sharedStyles from '../UserModals.module.css';
import styles from "../SelectionOffer/SelectionOffer.module.css";

const ErrorForm = ({show, onHide, alert, mother}) => {

    return (
        <div className={`${sharedStyles.modal} ${show ? sharedStyles.active : ''}`} onClick={onHide}>
            <div className={sharedStyles.modalContent} onClick={e => e.stopPropagation()}>
                <div className={sharedStyles.customCloseButton} onClick={onHide}>
                    &times;
                </div>

                {/* Фоновые кружки */}
                <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleBigCircleLeft}`}></div>
                <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleCircleTopLeft}`}></div>
                <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleCircleTopRight}`}></div>
                <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleCircleBottomLeft}`}></div>
                <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleCircleBottomRight}`}></div>
                <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleCircleCenter}`}></div>

                <div
                    className={sharedStyles.formInnerWrapper}
                    style={{margin: 'auto'}}
                >
                    <div
                        className={sharedStyles.formInnerWrapper}
                        style={{padding: '15px'}}
                    >
                        <div className={styles.telegramLogoArea}>
                            <div
                                className={sharedStyles.formLogoText}
                                style={{marginBottom: '10px', color: '#E53935'}}
                            >
                                Ошибка!
                            </div>
                        </div>

                        <div className={sharedStyles.formDescription}>
                            <h6 style={{fontWeight: "550", padding: "15px 0 15px 0"}}>{alert}</h6>
                            <h6>Попробуйте обновить страницу. Если это не поможет, обратитесь к технической поддержке</h6>
                        </div>


                        <button
                            className={sharedStyles.buttonSecondary}
                            onClick={onHide}
                        >
                            Закрыть
                        </button>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ErrorForm;